<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">支払方法管理</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-80 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100">
                <md-field>
                  <label>決済方法</label>
                  <md-select name="selectedBillMethod" id="billingMethod" v-model="form.selectedBillMethod"
                             :disabled="sending">
                    <md-option v-for="(billingMethod) in billingMethods" :key="'billing-method-' + billingMethod.code"
                               :value="billingMethod.code">
                      {{billingMethod.name}}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>送付方法</label>
                    <md-select name="selectedBillVia" id="billingVia" v-model="form.selectedBillVia"
                               :disabled="sending">
                      <md-option v-for="(billingViaItem) in billingVia" :key="'billing-via-' + billingViaItem.code"
                                 :value="billingViaItem.code">
                        {{billingViaItem.name}}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-alignment-center-left">
                <md-button @click="submitForm" class="md-primary md-raised" type="submit" :disabled="sending">
                  <md-icon>search</md-icon>
                  <span>表示する</span>
                </md-button>
              </div>
            </div>
          </div>
        </div>

        <md-table>
          <md-table-toolbar>
            <h1 class="md-title">一覧</h1>
          </md-table-toolbar>
          <md-table-row>
            <md-table-head><span></span></md-table-head>
            <md-table-head><span>支払情報の名称</span></md-table-head>
            <md-table-head><span>決済方法</span></md-table-head>
            <md-table-head><span>送付方法</span></md-table-head>
            <md-table-head><span>更新者（ユーザー名）</span></md-table-head>
            <md-table-head>
              <router-link :to="{name: 'BackendUserPaymentNew'}">
                <md-button class="md-primary md-raised" :disabled="sending">
                  <md-icon>add</md-icon>
                  <span>新規登録</span>
                </md-button>
              </router-link>
            </md-table-head>
          </md-table-row>
          <md-table-row v-if="loadPayments">
            <md-table-cell colspan="6">
              <loading-spinner></loading-spinner>
            </md-table-cell>
          </md-table-row>
          <md-table-row v-for="(paymentMethod, index) in paymentMethods" :key="'payment-' + index"
                        v-if="paymentMethods">
            <md-table-cell>
              <md-icon class="text-danger" v-if="paymentMethod.hasSetting">check</md-icon>
            </md-table-cell>
            <md-table-cell class="content-style">{{ paymentMethod.label}}</md-table-cell>
            <md-table-cell class="table-label content-style">{{ getBillMethodName(paymentMethod.bill_method) }}
            </md-table-cell>
            <md-table-cell class="table-label content-style">{{ getBillViaName(paymentMethod.bill_via) }}
            </md-table-cell>
            <md-table-cell class="table-label content-style">{{ getAccountName(paymentMethod.meta) }}
            </md-table-cell>
            <md-table-cell>
              <div class="flexbox">
                <div>
                  <router-link :to="{name: 'BackendUserPaymentNew', params: {id: paymentMethod.gmo_member_id}}"
                               class="md-button md-raised"
                               tag="md-button">
                    <md-icon>edit</md-icon>
                    <span>編集</span>
                  </router-link>
                </div>
                <div>
                  <md-button class="md-button md-raised md-accent" @click="onDelete(paymentMethod)">
                    <md-icon>delete</md-icon>
                    <span>削除</span>
                  </md-button>
                </div>
              </div>
            </md-table-cell>
          </md-table-row>
          <md-table-row v-if="paymentMethods && paymentMethods.length === 0">
            <md-table-cell colspan="6">{{ noDataMessage }}</md-table-cell>
          </md-table-row>
        </md-table>
        <div class="md-layout">
          <div class="md-layout-item md-size-80 md-small-size-100 text-danger">
            ※<md-icon class="text-danger">check</md-icon>は自部門に紐づく支払方法です。
          </div>
        </div>
      </md-card-content>
      <delete-modal
        :md-active.sync="showDeleteModal"
        :md-content="'以下の支払方法を削除します。<br><span>名称: ' + paymentDeleteName + '</span><br>よろしいですか？'"
        md-title="支払方法削除の確認"
        confirm-button-class="md-accent md-raised"
        cancel-button-class="md-raised"
        :sending="sending"
        @md-cancel="onDeleteCancel"
        @md-confirm="onDeleteConfirm"/>
      <md-snackbar :md-active.sync="showSnackBar"
                   :md-duration="snackbarDuration"
                   @md-closed="showSnackBar = false">
        <span>{{ successMessage }}</span>
        <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
      </md-snackbar>
      <md-snackbar :md-active.sync="showSnackBarError"
                   :md-duration="snackbarDuration"
                   @md-closed="showSnackBarError = false">
        <span>{{ snackbarErrorMessage }}</span>
        <md-button class="md-primary" @click="showSnackBarError = false">閉じる</md-button>
      </md-snackbar>
    </md-card>
  </main>

</template>

<script>
  import {apiClientWithUserToken as apiClient, apiList,} from '../../../modules/apiClient';
  import Common                                          from '../../../modules/common';
  import CommonMixin                                     from '../../../mixins/commonMixin';
  import DeleteModal                                     from '../../../components/DeleteModal';
  import LoadingSpinner                                  from '../../../components/LoadingSpinner';
  import {mapActions, mapGetters,}                       from 'vuex';
  import axios                                           from 'axios';

  export default {
    name      : "UserPayments",
    components: {LoadingSpinner, DeleteModal},
    mixins    : [CommonMixin],
    data      : () => ({
      form             : {
        selectedBillMethod: 'null',
        selectedBillVia   : 'null',
      },
      billingMethods   : [],
      billingVia       : [],
      paymentMethods   : null,
      paymentSettings  : null,
      paymentDeleteName: null,
      loadPayments     : false,
      accounts         : [],
    }),
    mounted   : function () {
      Promise.resolve(this.getSnackBar()).then(() => {
        if (this.successMessage && this.successMessage.length > 0) {
          const layoutComponent = this.$parent.$parent.$parent.$parent;
          layoutComponent.$refs['sidebar'].initDisplay();
        }
      });
      this.createBillingMethodOptions();
      this.createBillingViaOptions();
      this.getAccountList();
    },
    computed  : {
      ...mapGetters('payments', {
        formData : 'formData',
        isRefresh: 'isRefresh',
        isBack   : 'isBack',
      }),
    },
    methods   : {
      ...mapActions('payments', [
        'saveFormData',
        'saveRefresh',
        'saveBack',
      ]),
      getAccountList() {
        this.sending      = true;
        this.loadPayments = true;
        const self        = this;
        apiClient
          .get(apiList.accounts.list, {'with_trashed': 1})
          .then(response => {
            if (self.hasResponseErrors(response)) {
              return;
            }
            self.accounts = response.data.accounts;
          })
          .catch(error => {
            self.errorMessages = [error.message];
          })
          .finally(() => {
            this.applyState();
          });
      },
      applyState() {
        if ((this.isRefresh || this.isBack) && this.formData !== null) {
          this.form.selectedBillMethod = this.formData.selectedBillMethod;
          this.form.selectedBillVia    = this.formData.selectedBillVia;
        }
        this.saveRefresh(false);
        this.saveBack(false);
        this.submitForm();
      },
      submitForm() {
        this.saveFormData({
          selectedBillMethod: this.form.selectedBillMethod,
          selectedBillVia   : this.form.selectedBillVia,
        });
        this.paymentMethods  = null;
        this.paymentSettings = null;
        this.sending         = true;
        this.loadPayments    = true;
        axios
          .all([
            apiClient.get(apiList.payment.payment_methods.list),
            apiClient.get(apiList.payment.settings.list)
          ])
          .then(axios.spread((...responses) => {
            const paymentMethodResult  = responses[0].data;
            const paymentSettingResult = responses[1].data;
            if (paymentMethodResult.errors) {
              this.errorMessages = paymentMethodResult.errors;
              return;
            }
            if (paymentSettingResult.errors) {
              this.errorMessages = paymentSettingResult.errors;
              return;
            }
            this.paymentSettings = paymentSettingResult.data;
            this.filterPaymentMethods(paymentMethodResult.data);
          }))
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending      = false;
            this.loadPayments = false;
          })
      },
      filterPaymentMethods(paymentMethods) {
        this.paymentMethods = [];
        for (let paymentMethod of paymentMethods) {
          let matchBillMethod = this.form.selectedBillMethod === this.unspecified || _.toNumber(this.form.selectedBillMethod) === paymentMethod.bill_method;
          let matchBillVia    = this.form.selectedBillVia === this.unspecified || _.toNumber(this.form.selectedBillVia) === paymentMethod.bill_via;
          if (!(matchBillMethod && matchBillVia)) {
            continue;
          }
          this.paymentMethods.push(paymentMethod);
        }
        const currentGroupId  = Common.getCurrentUserInfo().group.id;
        const paymentSettings = this.paymentSettings.filter(paymentSetting => paymentSetting.group_id === currentGroupId);
        this.paymentMethods   = this.paymentMethods.map(paymentMethod => {
          paymentMethod = Object.assign(paymentMethod, {
            hasSetting: paymentSettings
              .filter(ps => ps.payment_method.gmo_member_id === paymentMethod.gmo_member_id).length > 0
          });
          return paymentMethod;
        });
      },
      onDelete(paymentMethod) {
        this.paymentDeleteName = paymentMethod.label;
        this.deleteInfo        = paymentMethod;
        this.showDeleteModal   = true;
      },
      onDeleteConfirm() {
        this.successMessage = null;
        this.sending        = true;
        const deleteUrl     = apiList.payment.payment_methods.delete.replace(':gmo_member_id', this.deleteInfo.gmo_member_id);
        apiClient.delete(deleteUrl)
          .then(response => {
            const result = response.data;
            if (result.errors) {
              this.snackbarErrorMessage = result.errors.pop();
              this.showSnackBarError    = true;
              return;
            }
            this.successMessage = Common.messages.paymentMethod.deleteSuccess;
            this.showSnackBar   = true;
            this.submitForm();
          })
          .catch(error => {
            this.snackbarErrorMessage = error.message;
            this.showSnackBarError    = true;
          })
          .finally(() => {
            this.deleteInfo      = null;
            this.showDeleteModal = false;
            this.sending         = false;
          });
      },
      onDeleteCancel() {
        this.deleteInfo      = null;
        this.showDeleteModal = false;
      },
      createBillingMethodOptions() {
        const billingMethods = [];
        billingMethods.push({code: this.unspecified, name: this.unspecifiedLabel});
        Object.keys(Common.billingMethods).forEach(function (billingMethodKey) {
          billingMethods.push({code: billingMethodKey, name: Common.billingMethods[billingMethodKey]});
        });
        this.billingMethods = [...billingMethods];
      },
      createBillingViaOptions() {
        const billingVia = [];
        billingVia.push({code: this.unspecified, name: this.unspecifiedLabel});
        Object.keys(Common.billingVia).forEach(function (billingViaKey) {
          billingVia.push({code: billingViaKey, name: Common.billingVia[billingViaKey]});
        });
        this.billingVia = [...billingVia];
      },
      getAccountName(meta) {
        if (meta === null || meta === undefined) {
          return '';
        }
        if (meta.account_id === null || meta.account_id === undefined) {
          return '';
        }
        const filtered = this.accounts.filter(account => account.account_id === meta.account_id);
        return filtered.length > 0 ? filtered[0].name : '';
      },
    },
  }
</script>

<style lang="scss" scoped>
  .md-table-head:nth-child(1),
  .md-table-cell:nth-child(1) {
    min-width: 36px;
    max-width: 36px;
    text-align: center;

    ::v-deep(.md-table-cell-container) {
      padding: 0 !important;
    }
  }

  .text-danger {
    color: red !important;
  }
</style>
